import React, { useEffect, useState } from "react";

import ShareModal from "../../molecules/share-modal/shareModal";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";
import DefaultImage from "../../../assets/images/not-found/Icono_vertical_portada_libro.jpg";

import "./cardReview.scss";
interface ReviewInterface {
  review: {
    redireccionBoton: string;
    tituloBanner: string;
    imagenPrincipal: any;
    titulo: string;
    mmsId: string;
  };
  gtmClass: string;
}

const CardReview = (props: ReviewInterface) => {
  const { review, gtmClass } = props;

  const [hrefUrl, setHrefUrl] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { window } = useBrowserMode();


  useEffect(() => {
    window.addEventListener("load", () =>
      setHrefUrl(`${window.location.origin}${review.redireccionBoton}`)
    );
  });

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <div className={`a-card-rev gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}>
      <a 
        href={review.redireccionBoton}
        className={`a-card-rev-content gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}
        rel={findRel(review.redireccionBoton)}
      >
        <div className={`a-card-rev-content-img gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}>
          <img
            className={`gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}
            src={
              review.imagenPrincipal
                ? review.imagenPrincipal[0].file.url
                : DefaultImage
            }
            alt={
              review.imagenPrincipal
                ? review.imagenPrincipal[0].title 
                  ? formatImageAlt(review.imagenPrincipal[0].title)
                  : review.tituloBanner
                : "Imagen portada"
            }
          />
        </div>
        <h3 className={`a-card-rev-content-title hide-on-mobile gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}>
          {review.tituloBanner}
        </h3>
        <h3 className={`a-card-rev-content-title show-on-mobile gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}`}>
          {review.tituloBanner}
        </h3>

        <span className="a-card-rev-content-separator" />
        <div className="a-card-rev-content-menu">
          <i
            className={`icon icon-share gtm${normalizeTwoWords(gtmClass)}${normalizeTwoWords(review.tituloBanner)}Compartir`}
            onClick={(e) => {
              toggleModal();
              e.stopPropagation();
            }}
          />
        </div>
      </a>
      {hrefUrl.length > 0 && (
        <ShareModal
          open={isModalVisible}
          onClose={toggleModal}
          href={hrefUrl}
        />
      )}
    </div>
  );
};

export default CardReview;
